import { useContext } from 'react';
import QuestionnaireFormContext, { QuestionnaireFormContextType } from './QuestionnaireFormContext';

const useQuestionnaireFormContext = (): QuestionnaireFormContextType => {
  const context = useContext(QuestionnaireFormContext);
  return context;
};

export default useQuestionnaireFormContext;